import React, { useEffect, useState } from "react";
import NoData from "../../Utils/Table/errlogo.png";
function Table1({
  columns,
  data,
  page = 1,
  totalPages = 1,
  onPageChange,
  initialRowsPerPage = 10,
  onRowsPerPageChange,
}) {
  const [perPage, setPerPage] = useState(initialRowsPerPage);

  useEffect(() => {
    setPerPage(initialRowsPerPage);
  }, [initialRowsPerPage]);

  const handlePerPageChange = (e) => {
    const newPerPage = Number(e.target.value);
    setPerPage(newPerPage);
    onPageChange && onPageChange(1);
    onRowsPerPageChange && onRowsPerPageChange(newPerPage);
  };

  return (
    <div className="table-responsive">


      <div
        className="table-container"
        style={{
          maxHeight: "420px",
          overflowY: "auto",
          borderBottom: "1px solid #ddd",
        }}
      >
          {data.length === 0 ? (  <div style={{ textAlign: "center", overflow: "hidden" }}>
                    <img src={NoData} className="nodata-combo" style={{ width: "250px" }} />
                    <h4 className="text-muted mt-2">No Data Available</h4>
                  </div> ) : (
        
        <table className="table table-striped mb-0">
          <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>
            <tr>
              {columns.map((col, i) => (
                <th key={i}>{col.Header}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.length > 0 && (
              data.map((row, i) => (
                <tr key={i}>
                  {columns.map((col, j) => {
                    const startIndex = (page - 1) * perPage;

                    if (col.Cell) {
                      return <td key={j}>{col.Cell({ row, index: i })}</td>;
                    }

                    if (col.id === "rowIndex") {
                      return <td key={j}>{startIndex + i + 1}</td>;
                    }

                    return <td key={j}>{row[col.accessor]}</td>;
                  })}
                </tr>
              ))
           
            )}
          </tbody>
        </table>
          )}
      </div>
      {data.length > 0 && (
      <div
        className="pagination d-flex justify-content-between align-items-center px-3 py-2"
        style={{
          position: "sticky",
          bottom: 0,
          background: "#fff",
          zIndex: 10,
        }}
      >

        <div className="d-flex align-items-center gap-2">
          <label className="mb-0">Rows per page:</label>
          <select
            className="form-select form-select-sm"
            style={{ width: 90 }}
            value={perPage}
            onChange={handlePerPageChange}
          >
            {[5, 10, 20, 50, 100].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>
        <div className="d-flex align-items-center gap-2">
          <button
            className="btn btn-outline-primary btn-sm"
            disabled={page === 1}
            onClick={() => onPageChange(page - 1)}
          >
            ◀ Prev
          </button>

          <span className="mx-2">
            Page {page} of {totalPages}
          </span>

          <button
            className="btn btn-outline-primary btn-sm"
            disabled={page === totalPages || totalPages === 0}
            onClick={() => onPageChange(page + 1)}
          >
            Next ▶
          </button>
        </div>
      </div>
      )}
    </div>
  );
}

export default Table1;
